(() => {
  angular.module('gm.common.services', [
    'gm.common.aurum-activity',
    'gm.common.crypto',
    'gm.common.exchange',
    'gm.common.gtm',
    'gm.common.location',
    'gm.common.mobile',
    'gm.common.phone',
    'gm.common.router',
    'gm.common.token',
    'gm.common.utils',
    'ipCookie',
  ]);
})();
